import React from 'react';
import './CalendarSelector.css';
import Calendar from 'react-calendar';

function CalendarSelector({ onChange, value, tileDisabled, tileClassName }) {
  return (
    <div className="calendar-selector">
      <Calendar
        onChange={onChange}
        value={value}
        locale="it-IT"
        tileDisabled={tileDisabled}
        tileClassName={tileClassName}
      />
    </div>
  );
}

export default CalendarSelector;
